import IconFood from "@Icons/searchRes/amenities/IconFood";
import IconType from "@/types/Icon.type";

function IconMealsGroup(props: IconType) {
    return (
        <IconFood {...props}/>
    )
}

export default IconMealsGroup